window.userAnalytics = {
  // Add an ID that's unique to this user's session in this window, so that
  // it's possible to correlate events if the user was working in multiple
  // windows at the same time.
  sessionID: (function () {
    return window.CREATOR_GUID || window.generateUUID()
  })(),
  track: function (event, inMetadata) {
    'use strict'

    var metadata = inMetadata || {}
    metadata.sessionID = this.sessionID
    var withAutomaticProperties = null
    var View

    var momentsState = window.OpalMoments && window.OpalMoments.State
    if (momentsState) {
      if (momentsState.current_brand) {
        metadata.brand_id = momentsState.current_brand.id
        metadata.opal_id = momentsState.current_brand.get('opal_id')
      } else if (momentsState.settings) {
        metadata.brand_id = momentsState.settings.get('current_brand_id')
      }
    }

    if (window.AppBase) View = AppBase.request('state:get_current_view')
    withAutomaticProperties = jQuery.extend(metadata, {
      'Browser Height': window.innerHeight,
      'Browser Width': window.innerWidth,
      locale: window.navigator.language,
      Platform: 'Web',
      'Screen Height': window.screen.height,
      'Screen Width': window.screen.width,
      title: window.top.document.title,
      url: window.location.toString(),
      View: metadata.View || View,
    })

    if (window.global_config.settings.enable_remote_logging) {
      jQuery.post(
        '/log/track_action',
        {
          event: event,
          metadata: withAutomaticProperties,
        },
        'json'
      )
    }
  },
}
